import { StaticBaseDao } from '@/dao';
import { CreateHeatPlanRequest, CreateHeatPlanResponse, PostResponse, HeatPlanBackupItem, TransferResponse } from '@/objects/generated';
import { formatDateIso } from '@/utilities/dateutils';

export class HeatPlanDao extends StaticBaseDao {
    public static async CreateHeatPlan(EventID: number, req: CreateHeatPlanRequest): Promise<CreateHeatPlanResponse | null> {
        return this.BaseFetch(
            CreateHeatPlanResponse,
            `HeatPlan/CreateHeatPlan` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            req,
        );
    }
    public static async SetStarttime(EventID: number, HeatplanID: number, Starttime: Date | null): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `HeatPlan/SetStarttime` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (HeatplanID == undefined ? '' : `HeatplanID=${HeatplanID}`) +
                '&' +
                (Starttime == undefined ? '' : `Starttime=${Starttime ? formatDateIso(Starttime) : null}`),
            'GET',
        );
    }
    public static async ArmHeat(EventID: number, HeatplanID: number, arm?: boolean): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `HeatPlan/ArmHeat` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (HeatplanID == undefined ? '' : `HeatplanID=${HeatplanID}`) +
                '&' +
                (arm == undefined ? '' : `arm=${arm}`),
            'GET',
        );
    }
    public static async ResetHeat(EventID: number, HeatplanID: number): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `HeatPlan/ResetHeat` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (HeatplanID == undefined ? '' : `HeatplanID=${HeatplanID}`),
            'GET',
        );
    }
    public static async ResetHeatStart(
        EventID: number,
        HeatplanID: number,
        resetBackupTimes: boolean,
        keepbibs: boolean,
    ): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `HeatPlan/ResetHeatStart` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (HeatplanID == undefined ? '' : `HeatplanID=${HeatplanID}`) +
                '&' +
                (resetBackupTimes == undefined ? '' : `resetBackupTimes=${resetBackupTimes}`) +
                '&' +
                (keepbibs == undefined ? '' : `keepbibs=${keepbibs}`),
            'GET',
        );
    }
    public static async SetBackupTime(EventID: number, item: HeatPlanBackupItem): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `HeatPlan/SetBackupTime` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            item,
        );
    }
    public static async GetBackupTimesForHeatPlan(EventID: number, HeatPlanID: number): Promise<HeatPlanBackupItem[]> {
        return this.BaseFetchArray(
            HeatPlanBackupItem,
            `HeatPlan/GetBackupTimesForHeatPlan` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (HeatPlanID == undefined ? '' : `HeatPlanID=${HeatPlanID}`),
            'GET',
        );
    }
    public static async GetBackupTimesForEvent(EventID: number): Promise<HeatPlanBackupItem[]> {
        return this.BaseFetchArray(
            HeatPlanBackupItem,
            `HeatPlan/GetBackupTimesForEvent` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
    public static async TransferHeatPlan(EventID: number, HeatPlanID: number): Promise<boolean | null> {
        return this.Get(
            `HeatPlan/TransferHeatPlan` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (HeatPlanID == undefined ? '' : `HeatPlanID=${HeatPlanID}`),
        );
    }
    public static async PreviewTransfer(EventID: number, RaceID: number, CategoryID: number): Promise<TransferResponse | null> {
        return this.BaseFetch(
            TransferResponse,
            `HeatPlan/PreviewTransfer` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (RaceID == undefined ? '' : `RaceID=${RaceID}`) +
                '&' +
                (CategoryID == undefined ? '' : `CategoryID=${CategoryID}`),
            'GET',
        );
    }
}
